document.addEventListener('turbo:load', function() {
  // Testimonials slider functionality
  const slider = document.getElementById('testimonials-slider');
  const prevBtn = document.getElementById('prev-btn');
  const nextBtn = document.getElementById('next-btn');
  const slides = document.querySelectorAll('.testimonial-slide');

  let currentIndex = 0;
  let autoSlideInterval;
  const slideWidth = 100; // 100% width
  const slideCount = slides.length;

  // Initialize slider
  function updateSlider() {
    slider.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
  }

  // Navigate to previous slide
  function prevSlide() {
    currentIndex = (currentIndex - 1 + slideCount) % slideCount;
    updateSlider();
  }

  // Navigate to next slide
  function nextSlide() {
    currentIndex = (currentIndex + 1) % slideCount;
    updateSlider();
  }

  // Start auto sliding
  function startAutoSlide() {
    stopAutoSlide();
    autoSlideInterval = setInterval(nextSlide, 8000); // Change slide every 5 seconds
  }

  // Stop auto sliding
  function stopAutoSlide() {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
    }
  }

  // Event listeners
  if(prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function() {
      prevSlide();
      startAutoSlide(); // Reset timer when manually navigating
    });

    nextBtn.addEventListener('click', function() {
      nextSlide();
      startAutoSlide(); // Reset timer when manually navigating
    });
  }

  // Initialize auto sliding
  if(slider && prevBtn && nextBtn && slides.length > 1) {
    startAutoSlide();
  }
});
